import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable, of, tap } from 'rxjs';
import { ICategoriesResponse } from '../../../models/interfaces/explore-service.interface';
import { StorageService } from '../../state-management/storage.service/storage.service';
import { AlbumSubscribeResponse } from '../../../models/interfaces/response';
import { LOCAL_STORAGE } from '../../../models/constant/constants';
import { Router } from '@angular/router';
import { RedirectManagerService } from '../../state-management/redirect.service/redirect-manager.service';
@Injectable({
  providedIn: 'root',
})
export class ExploreService {
  private baseUrl = environment.apiUrl;
  artistId: string | number;
  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private route: Router,
    private redirectService: RedirectManagerService,

  ) {
    this.artistId = this.storageService.getArtistId();
  }
  // cache = new Map<string, any>();

  getArtByCategory(
    category: string | number,
    page: number = 0,
    limit: number = 10,
  ): Observable<ICategoriesResponse> {

    let params = new HttpParams();

    params = params.set("category", category);
    // let queryParams = `category=${encodedCategory}`;
    if (limit) {
      params = params.set("limit", limit);
      params = params.set("page", page);
      // queryParams += `&limit=${limit}&page=${page}`;
    }
    const userId = this.storageService.getUserId();
    if (userId) {
      params = params.set("userId", userId);
    }

    const url = `${this.baseUrl}/getArtByCategory`;

    const key = url + params.get("category") + params.get("page") + params.get("limit");

    // if(this.cache.has(key)) {
    // return of(this.cache.get(key));
    // }

    return this.http.get<ICategoriesResponse>(url, { params })
    // .pipe(tap(data => this.cache.set(key, data)));
  }

  // post /api/v1/likeUnlikeArts/{artDetailId}
  likeUnlikeArts(artDetailId: any, artArtistId: number): Observable<any> {
    this.artistId = this.storageService.getArtistId();
    const headers = new HttpHeaders().set("no-loader", "yes");
    const url = `${this.baseUrl}/likeUnlikeArts/${artDetailId}?artistId=${artArtistId}`;
    return this.http.post(url, null, { headers });
  }

  // getTopTrendingArtists
  getTopTrendingArtists(limit = 15, page: number = 0): Observable<any> {
    let params = new HttpParams();
    let url = `${this.baseUrl}/getTopTrendingArtists`;

    // Add query parameters for pagination if provided
    if (limit !== undefined) {
      params = params.set("limit", limit);
    }

    const userId = this.storageService.getUserId();
    if (userId) {
      params = params.set("userId", userId);
    }

    return this.http.get(url, { params })
  }

  // get /api/v1/getTopArtistsOfTheWeek
  getTopArtistsOfTheWeek(limit?: number, page?: number): Observable<any> {
    let url = `${this.baseUrl}/getTopArtistsOfTheWeek`;


    let params = new HttpParams();

    // Add query parameters for pagination if provided
    if (limit !== undefined && page !== undefined) {
      params = params.set("limit", limit);
      params = params.set("page", page);
    }

    const userId = this.storageService.getUserId();
    if (userId) {
      params = params.set("userId", userId);
    }

    return this.http.get(url);
  }

  getTopArtOfTheWeek(limit?: number, page?: number): Observable<any> {
    const url = `${this.baseUrl}/getTop10ArtsOfTheWeek`;
    let params = new HttpParams();

    if (limit && page) {
      params = params.set("limit", limit);
      params = params.set("page", page);
    }

    const userId = this.storageService.getUserId();
    if (userId) {
      params = params.set("userId", userId);
    }


    // if(this.cache.has(url)) {
    //   return of(this.cache.get(url));
    // }
    return this.http.get(url, { params })
    // .pipe(tap(data => this.cache.set(url, data)));
  }

  // post /api/v1/followUnfollowArtist/{artistId}
  followUnfollowArtist(artistId: string | number): Observable<any> {
    const url = `${this.baseUrl}/followUnfollowArtist/${artistId}`;
    return this.http.post(url, {});
  }

  // get /api/v1/getFollowStatusArtist/{artistId}
  getFollowStatusArtist(artistId: string | number) {
    const url = `${this.baseUrl}/getFollowStatusArtist/${artistId}`;
    return this.http.get(url);
  }

  getArtistProfileById(artistId: string | number) {
    let params = new HttpParams();
    const userId = this.storageService.getUserId();
    if (userId) {
      params = params.set("userId", userId);
    }
    return this.http.get(`${this.baseUrl}/getArtistProfileById/${artistId}`, { params });
  }

  getArtistByArtistUserName(artistUserName: string) {
    let params = new HttpParams();
    const userId = this.storageService.getUserId();
    if (userId) {
      params = params.set("userId", userId);
    }
    return this.http.get(`${this.baseUrl}/getArtistProfileByUserName/${artistUserName}`, { params });
  }

  getArtistAlbumByArtistId(
    artistId: string | number,
    limit?: number,
    page: number = 0
  ): Observable<any> {

    let params = new HttpParams();

    if (limit) {
      params = params.set("limit", limit);
      params = params.set("page", page);
    }
    const userId = this.storageService.getUserId();
    if (userId) {
      params = params.set("userId", userId);
    }
    return this.http.get(`${this.baseUrl}/getArtistAlbumByArtistId/${artistId}`, { params });
  }


  getArtsByArtistId(
    artistId: string | number,
    limit?: number,
    page?: number
  ): Observable<any> {
    let params = new HttpParams();
    const userId = this.storageService.getUserId();
    if (userId) {
      params = params.set("userId", userId);
    }

    if (limit) {
      params = params.set("limit", limit);
      params = params.set("page", page as number);
    }
    return this.http.get(`${this.baseUrl}/getArtsOfArtistByArtistId/${artistId}`, { params });
  }

  getArtsOfArtistNotInAlbumByArtistId(
    artistId: string | number,
    limit?: number,
    page?: number
  ): Observable<any> {
    let params = new HttpParams();
    const userId = this.storageService.getUserId();
    if (userId) {
      params = params.set("userId", userId);
    }

    if (limit) {
      params = params.set("limit", limit);
      params = params.set("page", page as number);
    }
    return this.http.get(`${this.baseUrl}/getArtsOfArtistNotInAlbumByArtistId/${artistId}`, { params });
  }

  // get /api/v1/getTopSubscribedArtsOfAnArtist/{artistId}
  getTopSubscribedArtsOfAnArtist(
    artistId: string | number,
    limit: number = 15,
    page: number = 0
  ): Observable<any> {

    let params = new HttpParams();
    params = params.set("page", page);

    if (limit) {
      params = params.set("limit", limit);
    }
    const userId = this.storageService.getUserId();
    if (userId) {
      params = params.set("userId", userId);
    }
    return this.http.get(`${this.baseUrl}/getTopSubscribedArtsOfAnArtist/${artistId}`, { params });
  }

  getArtsGroupedByCountries(limit?: number, page: number = 0) {
    const url = `${this.baseUrl}/getArtsGroupedByCountries`;
    let params = new HttpParams();

    if (limit) {
      params = params.set("limit", limit);
      params = params.set("page", page);
    }
    const userId = this.storageService.getUserId();
    if (userId) {
      params = params.set("userId", userId);
    }

    const key = url + params.get('page') + params.get("page");

    // if(this.cache.has(key)) {
    //   return of(this.cache.get(key));
    // }
    return this.http.get(url, { params })
    // .pipe(tap(data => this.cache.set(key, data)));
  }

  getRecentSearch(audienceId: number): Observable<any> {
    const url = `${this.baseUrl}/getRecentSearches/${audienceId}`;
    return this.http.get(url);
  }

  subscribeAlbum(albumIds: (number | string)[], paymentMethodId: string | null = null): Observable<AlbumSubscribeResponse> {
    this.redirectService.saveRoute('onSubscribe', this.route.url);

    let params = new HttpParams()
      .set('albumIdList', albumIds.join(','));
    if (paymentMethodId) {
      params = params.set('paymentMethodId', paymentMethodId);
    }
    return this.http.post<AlbumSubscribeResponse>(`${this.baseUrl}/subscribeInAppPurchaseAlbumsSubscription`, null, { params });
  }

  getNotifications(limit: number, page: number): Observable<any> {
    const userId = JSON.parse(this.storageService.getUserData(LOCAL_STORAGE.USER_DETAILS) || "{}")?.userId;
    if (!userId) {
      console.log("Missing userId");
      return of({ error: { message: "Missing userId" } });
    }
    const params = new HttpParams()
      .set('limit', limit.toString())
      .set('page', page.toString());
    const headers = new HttpHeaders().set('no-loader', 'yes');

    return this.http.get<any>(`${this.baseUrl}/getNotification/${userId}`, { params, headers });
  }

  addBankDetails(artistId: number, bankData: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/addArtistBankDetails/${artistId}`, bankData);
  }


  getBankDetails(artistId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/getArtistBankDetails?artistId=${artistId}`);
  }

  requestPrice(artId: number): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/sendArtistArtPricingMissingEmail/${artId}`, null);
  }

  markAsRead(ids: Array<number>): Observable<any> {
    const params = new HttpParams().set('notificationIdList', ids.join(","));
    const headers = new HttpHeaders().set('no-loader', 'yes');
    return this.http.put<any>(`${this.baseUrl}/updateNotification`, null, { params, headers });
  }
}
